import { useEngineInstance } from '@surveycake/react-logic-engine';
import { PageService } from 'app/core/page';
import { ExceptionService } from 'app/core/status';
import { useSurveyConfig } from 'app/core/survey-config';
import {
  CheckThirdPartyLoginDeps,
  SetIsCompleted
} from 'app/modules/third-party-login';
import {
  checkFacebookLogin,
  useFaceboockSdk
} from 'app/modules/third-party-login/facebook';
import { Button } from 'app/shared/components';
import React, { useCallback } from 'react';
import { useStyles } from './styles';

function Facebook({ setIsCompleted }: { setIsCompleted: SetIsCompleted }) {
  const surveyConfig = useSurveyConfig();
  const engine = useEngineInstance();
  const { wording } = surveyConfig;
  const isInitialed = useFaceboockSdk();
  const setPage = PageService.useSetPage();
  const setException = ExceptionService.useSetException();
  const checkFacebookLoginDeps: CheckThirdPartyLoginDeps = [
    surveyConfig,
    engine,
    setPage,
    setException,
    setIsCompleted
  ];
  const onClick = useCallback(
    () => checkFacebookLogin(checkFacebookLoginDeps),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    checkFacebookLoginDeps
  );
  const styles = useStyles();

  return (
    <Button
      className={styles.facebook}
      loading={!isInitialed}
      onClick={onClick}
    >
      <span>
        <svg
          className={styles.facebookIcon}
          viewBox="0 0 320 512"
          fill="currentColor"
        >
          <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
        </svg>
        {wording.module.third_party_login.facebook}
      </span>
    </Button>
  );
}

export default Facebook;
